import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

// 1-tap attendance: everyone defaults to Present, teacher only taps the absentees.
function TeacherAttendanceCard({ user, cls, students, todayRecords, today, onSaved }) {
  const [status, setStatus] = useState({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const next = {};
    students.forEach((s) => {
      const rec = todayRecords.find((r) => r.studentId === s._id);
      next[s._id] = rec ? rec.status : 'present';
    });
    setStatus(next);
  }, [students, todayRecords]);

  const absent = students.filter((s) => status[s._id] === 'absent').length;

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await axios.post(`${API_BASE_URL}/api/attendance-records/bulk`, {
        attendanceRecords: students.map((s) => ({
          studentId: s._id,
          class: cls,
          date: today,
          status: status[s._id] || 'present',
          markedBy: user.name || 'Teacher'
        }))
      });
      setSaved(true);
      onSaved();
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      setError(e?.response?.data?.message || 'Could not save attendance. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="th-card">
      <div className="th-card-head">
        <h2>Attendance</h2>
        <span className="th-muted">{students.length - absent} present · {absent} absent</span>
      </div>
      {students.length === 0 ? (
        <p className="th-empty">No students in this class.</p>
      ) : (
        <ul className="th-list">
          {students.map((s) => (
            <li key={s._id} className="th-row">
              <span className="th-row-title">{s.name}</span>
              <span className="th-toggle">
                <button type="button" className={`th-pa th-p ${status[s._id] === 'present' ? 'on' : ''}`}
                  onClick={() => setStatus((p) => ({ ...p, [s._id]: 'present' }))}>P</button>
                <button type="button" className={`th-pa th-a ${status[s._id] === 'absent' ? 'on' : ''}`}
                  onClick={() => setStatus((p) => ({ ...p, [s._id]: 'absent' }))}>A</button>
              </span>
            </li>
          ))}
        </ul>
      )}
      {error && <div className="th-error">{error}</div>}
      <button className={`th-btn th-btn-block ${saved ? 'th-btn-ok' : ''}`} onClick={save}
        disabled={saving || students.length === 0}>
        {saving ? 'Saving…' : saved ? 'Saved ✓' : 'Save Attendance'}
      </button>
    </section>
  );
}

export default TeacherAttendanceCard;
